<template>
    <div :id="'_id' + message.id" class="flex group w-fit  items-end lg:max-w-[40%] max-w-[80%]">

        <div v-if="!selfMessage">
            <img :src="conversation?.profile" v-if="conversation?.profile" alt=""
                class="w-8 h-8 rounded-full dark:hidden" />
            <img src="@/assets/user5.svg" v-else alt="" class="w-8 h-8 rounded-full  dark:hidden" />

        </div>
        <div class="rounded-md ">


            <div class="flex justify-between">
                <div class="flex items-center w-fit rounded-lg  mb-1 text-xs text-gray-500 ">
                    <i class=" fas fa-share mr-2   " v-if="message.isForwarded"></i>
                    <i v-if="message.isForwarded">Transféré</i>
                </div>
                <div class="text-end font-bold mb-1">
                    {{ message?.agent?.firstname ?? "" }}
                </div>
            </div>

            <div v-if="message.parent" @click="scrollToParentMessage"
                class=" w-full cursor-pointer hover:scale-95 bg-gray-900/20 border-l-4 border-l-gray-900/60  rounded-md  mb-2 flex ">

                <div class=" mx-2 line-clamp-3" >
                    <ReplyWidget :message="message.parent" />
                </div>

            </div>

            <ImageViewer  :src="message.content" />
            <!-- <img  width="50" alt="Sticker" :src=""> -->


        </div>
        <div class="px-2 py-1 hover:scale-95 group-hover:bg-gray-200  cursor-pointer ml-3 group-hover:visible invisible rounded-full"
            :class="selfMessage ? 'order-first ' : ''" @click="setParentReply">
            <i class="fas fa-reply  text-xs"></i>
        </div>

    </div>



</template>
<script>
import ImageViewer from '@/pages/customComponents/ImageViewer.vue';
import { mapFields } from 'vuex-map-fields';
import ReplyWidget from './ReplyWidget.vue';

export default {
    name: "StickerMessage",
    components: {
        ImageViewer,
        ReplyWidget
    },
    props: {
        conversation: {
            type: Object,
            required: true
        },
        message: {
            type: Object,
            required: true
        },
        hour: {
            type: String,
            required: true
        },
        selfMessage: {
            type: Boolean,
            default() {
                return false
            }
        }
    },
    computed: {
        ...mapFields("messages/reply", {
            parentReply: "parentReply"
        })
    },
    methods: {
        setParentReply() {
            this.parentReply = this.message
        },
        scrollToParentMessage() {
            document.querySelector(`#_id${this.message?.parent_intern_id}`)?.scrollIntoView({ behavior: "smooth", block: "end", inline: "nearest" })
        }
    }
}
</script>